import {useState} from "react";
import {useHandleCustomFieldsForObject} from "../../hooks/useHandleCustomFieldsForObject";

export const useGetData = (objectType, objectId) => {
  const [customFields, setCustomFields] = useState([]);

  const handleCustomFieldsSet = (data) => {
    const updated = data.map((item) => {
      let display = item.value;

      if (item.options && item.value) {
        if (Array.isArray(item.value)) {
          // multiselect
          display = item.value.map((val) => {
            const match = item.options.find((opt) => opt.value === val);
            return match ? match.label : val;
          });
        } else {
          // single select
          const match = item.options.find((opt) => opt.value === item.value);
          display = match ? match.label : item.value;
        }
      }

      return {
        ...item,
        value: display,
      };
    });

    setCustomFields(updated);
  };

  useHandleCustomFieldsForObject(objectType, objectId, handleCustomFieldsSet);

  return {customFields};
};
